import App from "@/components/login";
import { wrapper } from "@/redux/store/store";
import { withCommonData } from "@/hocs/with-common-data";
import { withEhqPfe } from "@/hocs/with-ehq-pfe";
import { withParticipantData } from "@/hocs/with-participant-data";
import EHQLayout from "@/components/shared/layouts/ehq/default";
import type { GetServerSideProps, GetServerSidePropsContext } from "next";
import { fetchParticipationConfigurations } from "@/redux/features/participation-configurations/thunk";
import { withUserSession } from "@/hocs/with-user-session";
import type { ReactElement } from "react";
import { SingleColumnLayout } from "@/storybook-components";

export default function Page() {
  return <App />;
}

Page.getLayout = function getLayout(page: ReactElement) {
  return (
    <EHQLayout>
      <SingleColumnLayout>{page}</SingleColumnLayout>
    </EHQLayout>
  );
};

export const getServerSideProps: GetServerSideProps = withCommonData(
  withEhqPfe(
    withParticipantData(
      withUserSession(
        wrapper.getServerSideProps(
          (store) => async (ctx: GetServerSidePropsContext) => {
            const config = {
              headers: {
                cookie: ctx?.req?.headers?.cookie
              }
            };
            await store.dispatch(fetchParticipationConfigurations({ config }));
            return {
              props: {}
            };
          }
        )
      )
    )
  )
);
